import { useRef, useState } from 'react'

import { filterReturnPortalsBySearch } from '@/common/components/PageLayout/Header/ReturnPortalSelector/helpers'

const useReturnPortalSelector = ({ returnPortals, selectedReturnPortal }) => {
  const hasMultipleReturnPortals = returnPortals?.length > 1
  const [anchorEl, setAnchorEl] = useState(null)
  const ref = useRef()
  const [searchValue, setSearchValue] = useState('')
  const isReturnPortalSelected = portalId => selectedReturnPortal?.id === portalId

  const onOpenPopover = () => {
    if (hasMultipleReturnPortals) {
      setAnchorEl(ref.current)
    }
  }

  const onClosePopover = () => {
    setAnchorEl(null)
  }

  const returnPortalsToRender = filterReturnPortalsBySearch(searchValue, returnPortals || [])

  return {
    anchorEl,
    ref,
    onOpenPopover,
    onClosePopover,
    isOpen: Boolean(anchorEl),
    searchValue,
    setSearchValue,
    isReturnPortalSelected,
    returnPortalsToRender,
    hasMultipleReturnPortals,
  }
}

export default useReturnPortalSelector
